<template>
    <div>
        <template
                v-for="({labs, radiology, practitioner, condition, lab, created_at, id, observations}, i) in encounterDiagnosticReportGroups">
            <test-card
                    @click="show(i)"
                    :show="Boolean(observations)"
                    :doctor_name="practitioner.first_name + ' ' + practitioner.last_name"
                    :date="created_at" :summary="condition ? condition[nameKey] : '-'"
                    :lab_name="lab ? lab.first_name + ' ' + lab.last_name : '-'"
                    :tests="labs.length ? labs : radiology"
                    :icon="labs.length ? 'i-test-tube-pink' : 'i-radiology-no-bg'"
                    :icon-class="labs.length ? 'bg-somewhat-light-red' : 'bg-somewhat-light-skyler'"
                    :card-class="labs.length ? 'bg-extremely-light-red' : 'bg-extremely-light-skyler'"
                    :key="id"></test-card>
        </template>

        <infinite-loading @infinite="load">
            <span slot="no-more"></span>
            <span slot="no-results"></span>
        </infinite-loading>

        <span slot="no-results" class="position-absolute absolute-center"
              v-if="complete && encounterDiagnosticReportGroups.length === 0">{{t('No results')}}</span>

        <b-modal id="details" :title="t('More information')" scrollable centered hide-footer header-class="pl-4"
                 content-class="border-radius-1">
            <template
                    v-if="encounterDiagnosticReportGroups[index]">
                <div>
                    <small class="d-flex font-weight-bolder">{{t('Note')}}</small>
                    <small class="d-flex">{{encounterDiagnosticReportGroups[index].observations[0].note}}</small>
                </div>

                <template v-if="encounterDiagnosticReportGroups[index].observations[0].media.length">
                    <hr>

                    <small class="d-block mx-2 mb-2 font-weight-bolder">Attachments</small>

                    <div class="d-flex mx-2 justify-content-start py-2 overflow-auto">
                        <template v-for="media in encounterDiagnosticReportGroups[index].observations[0].media">
                            <component :class="margin" :is="media.mime_type.split('/')[0] + '-thumbnail'"
                                       :src="media.full_url"
                                       @click="showMedia(media)"
                                       :key="media.id"/>
                        </template>
                    </div>
                </template>
            </template>
        </b-modal>

        <viewer @close="closeMedia" :media="mediaToShow"/>
    </div>
</template>

<script>
    import TestCard from "../../components/Cards/TestCard";
    import InfiniteLoading from 'vue-infinite-loading';
    import IPrimaryDiagnoses from "../../components/Icons/IPrimaryDiagnoses";
    import Viewer from "../../components/Viewer";
    import ImageThumbnail from "../../components/MediaThumbnails/ImageThumbnail";
    import VideoThumbnail from "../../components/MediaThumbnails/VideoThumbnail";
    import ApplicationThumbnail from "../../components/MediaThumbnails/ApplicationThumbnail";

    export default {
        name: "Labs",
        components: {
            TestCard, InfiniteLoading,
            Viewer,
            ImageThumbnail,
            VideoThumbnail,
            ApplicationThumbnail
        },
        inject: ['dataRepo'],
        data: () => ({
            encounterDiagnosticReportGroups: [],
            page: 0,
            index: null,
            complete: false,
            mediaToShow: null
        }),
        computed: {
            margin() {
                return this.$translate.lang === 'en' ? 'mr-3' : 'ml-3'
            },

            nameKey() {
                return `name_${this.$translate.lang}`
            }
        },
        methods: {
            load(state) {
                this.dataRepo.encountersWithTests(this.page)
                    .then(data => {
                        if (data) {
                            this.encounterDiagnosticReportGroups.push(...data.data)
                            state.loaded();
                            this.page++;
                        }

                        if (!data || data.data.length < 5) {
                            state.complete();
                            this.complete = true
                        }
                    })
                    .catch(err => this.$handleError(err))
            },

            show(index) {
                if (this.encounterDiagnosticReportGroups[index].observations) {
                    this.index = index;

                    this.$bvModal.show('details');
                }
            },

            showMedia(media) {
                if (media.mime_type.split('/')[0] === 'application' || media.mime_type.split('/')[1] === 'x-ms-asf') {
                    window.open(media.full_url)
                } else {
                    this.mediaToShow = media
                }
            },

            closeMedia() {
                this.mediaToShow = null
            }
        }
    }
</script>

<style scoped>

</style>
